export default {"src":"/_next/static/media/edible-garden.04d43fb0.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};